module.exports = __webpack_public_path__ + "static/media/19ESCAP25.d3b4e4c3.jpg";